<script setup lang="ts">
import {
  ElNotification, UploadFile,
  UploadInstance,
  UploadRequestOptions,
  UploadUserFile
} from "element-plus";
import {uploadFile} from "@/utils/cos.ts";
import {ProgressInfo} from "cos-js-sdk-v5";
import {ref} from "vue";
import {SectionService} from "@/api/api.ts";
import {getFileExt} from "@/utils/common.ts";
import {CourseFile} from "@/types";
import FileListDialog from "components/dialog/common/FileListDialog.vue";

const fileListDialog = ref<InstanceType<typeof FileListDialog>>()
const upload = ref<UploadInstance>()
const fileList = ref<UploadUserFile[]>([])
let fileId = 0

const uploadPdf = (options: UploadRequestOptions) => {
  if (options.file) {
    uploadFile(options.file, {
      onTaskReady: (taskId: string) => {
        console.log(taskId)
        fileList.value = fileList.value.map((item) => {
          if (item.uid === options.file.uid) {
            item.status = "uploading"
          }
          return item
        })
      },
      onProgress: (progressData: ProgressInfo) => {
        console.log(progressData.percent)
        fileList.value = fileList.value.map((item) => {
          if (item.uid === options.file.uid) {
            item.percentage = progressData.percent * 100
          }
          return item
        })
      },
      onUploadFail: (err: string) => {
        console.log(err)
      },
      onFileFinish: (url: string) => {
        if (fileList.value[0]) {
          SectionService.addCourseFile({
            name: fileList.value[0].name,
            size: fileList.value[0].size || 0,
            url: url,
            ext: getFileExt(fileList.value[0].name),
          }).then(res => {
            if (res.data.code === 200) {
              fileId = res.data.data as number
              fileList.value = fileList.value.map((item) => {
                if (item.uid === options.file.uid) {
                  item.url = url
                  item.status = "success"
                }
                return item
              })
            } else {
              ElNotification.error({
                title: "上传文件失败",
                message: res.data.msg,
                type: "error"
              })
              fileList.value = fileList.value.map((item) => {
                if (item.uid === options.file.uid) {
                  item.status = "fail"
                }
                return item
              })
            }
          }).catch(() => {
            fileList.value = fileList.value.map((item) => {
              if (item.uid === options.file.uid) {
                item.status = "fail"
              }
              return item
            })
          })
        }
      }
    })
  }
}

const getFileId = () => {
  return fileId
}

const onSelectFile = (id: number, name: string, url: string) => {
  const userFile: UploadUserFile = {
    name: name,
    size: 0,
    url: url,
    uid: id,
    status: "success",
  }
  fileId = id
  fileList.value = [userFile]
  fileListDialog.value?.hide()
}

const initFileList = (file: CourseFile) => {
  if (file && file.id) {
    const userFile: UploadUserFile = {
      name: file.name,
      size: 0,
      url: file.path,
      uid: file.id,
      status: "success",
    }
    fileList.value = [userFile]
  }
}

const handlePreview = (file: UploadFile) => {
  if (file.url) {
    window.open(file.url, "_blank");
  }
}

const clearFile = () => {
  fileList.value = []
  fileId = 0
}

const selectFile = () => {
  fileListDialog.value?.show()
}

defineExpose({
  initFileList, getFileId, clearFile
})
</script>

<template>
  <div class="flex items-center justify-center">
    <el-upload
        v-model:file-list="fileList"
        ref="upload"
        :http-request="uploadPdf"
        :limit="1"
        accept=".pdf,.docx,.doc,.pptx,.ppt,.xls,.xlsx,.txt"
        :on-preview="handlePreview">
      <el-button class="ml-1rem" type="warning" @click="selectFile" :disabled="fileList.length >= 1">选择文件</el-button>
      <template #trigger>
        <el-button type="primary" :disabled="fileList.length >= 1">上传文件</el-button>
      </template>
    </el-upload>
  </div>
  <file-list-dialog ref="fileListDialog" @on-select-file="onSelectFile" />
</template>

<style scoped>
</style>